import { toaster } from '@/utils/toaster';
import { RSUITE_ALERT_DURATION } from '@/constants';
import { ERROR_MESSAGES } from '@/error-boundaries/errors';

export const SUCCESS_TYPES = {
  PASSWORD_CHANGE: 'PASSWORD_CHANGE',
  USERNAME_UPDATE: 'USERNAME_UPDATE',
  DATA_LOCKED: 'DATA_LOCKED',
  DATA_RELEASED: 'DATA_RELEASED',
};

const SUCCESS_MESSAGES = {
  PASSWORD_CHANGE: 'Password Successfully Changed',
  USERNAME_UPDATE: 'Username Successfully Updated',
  DATA_LOCKED: 'City data locked',
  DATA_RELEASED: 'City data released',
};

export class MappedAlerts {
  /**
   * Displays an error message, which has been mapped within error-boundary/errors.js
   * @param {String} errorCode key to be searched within error messages map
   * @param {Number} duration duration to show the alert for, defaults to 10 seconds
   */
  static error(errorCode, duration = RSUITE_ALERT_DURATION.LONG) {
    try {
      toaster.error(ERROR_MESSAGES[errorCode], duration);
    } catch (error) {
      toaster.error(ERROR_MESSAGES.DefaultException, duration);
    }
  }

  /**
   * Displays a success message, which has been mapped within the SUCCESS_MESSAGES map
   * @param {String} successCode key to be searched within success messages map
   * @param {Number} duration duration to show the alert for, defaults to 5000
   */
  static success(successCode, duration = RSUITE_ALERT_DURATION.DEFAULT) {
    toaster.success(SUCCESS_MESSAGES[successCode], duration);
  }
}
